import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EmailTemplatesListComponent } from './email-templates-list/email-templates-list.component';
import { RouteApplicationStartupResolveService } from '@admin/core/route-application-startup-resolve.service';
import { EmailTemplateEditorComponent } from './email-template-editor/email-template-editor.component';
import { SettingsShellComponent } from './settings-shell/settings-shell.component';
import { SettingsLookupResolveService } from './shared/services/settings-lookup-resolve.service';

import { SettingsMainComponent } from './settings-main/settings-main.component';
import { SystemConfigurationComponent } from './system-configuration/system-configuration.component';
import { AdminUsersComponent } from './admin-users/admin-users.component';
import { AdminNewComponent } from './admin-new/admin-new.component';
import { AdminEditComponent } from './admin-edit/admin-edit.component';

import { InfoPagesComponent } from './info-pages/info-pages.component';
import { InfoPagesEditComponent } from './info-pages-edit/info-pages-edit.component';
import { EmailSmsTemplatesListComponent } from './email-sms-templates-list/email-sms-templates-list.component';
import { AdsManagePageComponent } from './ads-manage-page/ads-manage-page.component';
import { AdsTabComponent } from './ads-tab/ads-tab.component';
import { AdsEditTabComponent } from './ads-edit-tab/ads-edit-tab.component';
import { AuthGuard } from '../core/auth.guard';

const settingsRoutes: Routes = [
  {
    path: 'settings',
    component: SettingsShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: SettingsLookupResolveService,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'main',
      },
      {
        path: 'main',
        component: SettingsMainComponent,
      },
      {
        path: 'system-configuration',
        component: SystemConfigurationComponent,
      },
      {
        path: 'admin-users',
        component: AdminUsersComponent,
      },
      {
        path: 'admin-new',
        component: AdminNewComponent,
      },
      {
        path: 'admin-edit/:id',
        component: AdminEditComponent,
      },
      {
        path: 'template-list',
        component: EmailSmsTemplatesListComponent,
      },
      {
        path: 'promo-emails',
        component: EmailTemplatesListComponent,
      },
      {
        path: 'template-editor',
        component: EmailTemplateEditorComponent,
      },
      {
        path: 'template-editor/:id',
        component: EmailTemplateEditorComponent,
      },
      {
        path: 'info-pages',
        component: InfoPagesComponent,
      },
      {
        path: 'info-pages-edit/:id/:name/:title/:alias',
        component: InfoPagesEditComponent,
      },
      {
        path: 'banner-positions',
        component: AdsManagePageComponent,
      },
      {
        path: 'banner-positions/:id/banners',
        component: AdsTabComponent,
      },
      {
        path: 'banner-positions/:positionId/banners/add',
        component: AdsEditTabComponent,
      },
      {
        path: 'banner-positions/:positionId/banners/:bannerId',
        component: AdsEditTabComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(settingsRoutes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
